import Box from '@mui/material/Box';
import React from 'react';

import { EmploymentRecord } from 'utils/employment/types';
import ReadOnlyEmploymentCard from './ReadOnlyEmploymentCard';

import styles from './BiographyEmploymentTimeline.module.scss';

export interface ReadOnlyEmploymentTimelineProps {
  /** Array of employment records to display in timeline */
  employmentRecords: EmploymentRecord[];
  /** Test ID for testing */
  testId?: string;
}

const ReadOnlyEmploymentTimeline: React.FC<ReadOnlyEmploymentTimelineProps> = ({
  employmentRecords,
  testId,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        // Add proper spacing like edit section - allows timeline lines to extend
        paddingLeft: { xs: 1, sm: 1.5 },
        paddingRight: { xs: 1, sm: 1.5 },
        // Allow overflow so timeline lines can extend beyond container
        overflow: 'visible',
      }}
      data-testid={testId}
    >
      {employmentRecords.map((employment, index) => (
        <ReadOnlyEmploymentCard
          key={employment.id}
          employment={employment}
          index={index}
          isLast={index === employmentRecords.length - 1}
          testId={`${testId}-card-${employment.id}`}
        />
      ))}
    </Box>
  );
};

export default ReadOnlyEmploymentTimeline; 